module.exports = __webpack_public_path__ + "static/Plan_Sanierungsgebiet-1a494f34669108f0a2bb591821c133ae.png";